module.exports = __webpack_public_path__ + "static/greetingImage@3x-2d12a8a80d6e7d61a92cf38048577821.png";